<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Sucursales
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Sucursales</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-header">
      <div></div>
      <button type="button" mdbBtn color="info" (click)="agregarSucursal.show()" size="sm" mdbWavesEffect>
        Agregar
      </button>
    </div>



  </div>

</div>

<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            
            <th scope="col">Nombre</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            
            <td>Sucursal</td>
            <td>
              <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                mdbTooltip="Editar" placement="right" (click)="agregarSucursal.show()">
                <mdb-icon fas icon="pen"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- MODAL Agregar Sucursal-->
<div mdbModal style="overflow-y: auto" #agregarSucursal="mdb-modal" class="modal fade" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <form>
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="agregarSucursal.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">
                  Datos de Sucursal
                </h5>
              </div>
            </div>

            <div class="row filtros-body" style="border-bottom: 1px solid #dee2e6">
              <div class="col">

                <div class="md-form">
                  <input value="" type="text" id="nombreSucursal" class="form-control" placeholder="99.999.999-9"
                    required #nombreSucursal />
                  <label for="nombreSucursal">Nombre</label>
                </div>
                <div class="switch info-switch">
                  <h5>Estado</h5>
                  <label>Inactivo<input class="form-check-input" type="checkbox" id="estado" formControlName="estado" />
                    <span class="lever"></span>Activo</label>
                </div>
              </div>
            </div>


          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
            (click)="agregarSucursal.hide()" mdbWavesEffect>
            Cerrar
          </button>
          <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect type="submit">
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>